import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useTitle } from 'react-use';

import { MODAL_NEW_MESSAGE } from '@/components/organisms/Modals/ModalConductor';
import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { pushModal } from '@/redux/modals/actions';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

export default function Conversations() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useSegments(PageName.CONVERSATIONS);

  useTitle(t('pages.chat_simple'));

  const handleSendMessage = () => {
    dispatch(pushModal(MODAL_NEW_MESSAGE, {}));
  };

  return (
    <div className="flex h-screen w-full flex-1 flex-col overflow-hidden bg-subtle pt-4">
      <Empty>
        <EmptyHeader>
          <EmptyMedia>
            <img src="/assets/empty-states/chat.webp" alt="" />
          </EmptyMedia>
          <EmptyTitle>{t('conversation.no_active_conversation.title')}</EmptyTitle>
          <EmptyDescription>
            {t('conversation.no_active_conversation.description')}
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button size="sm" onClick={handleSendMessage}>
            {t('conversation.no_active_conversation.button')}
          </Button>
        </EmptyContent>
      </Empty>
    </div>
  );
}
